<script setup lang="ts">
  const cookieDeclarationRef = ref<HTMLElement | null>(null);

  const { locale } = useI18n();

  const { cookieDeclaration } = useCookiebot({
    culture: locale.value
  });

  onMounted(() => {
    cookieDeclaration(cookieDeclarationRef);
  });
</script>

<template>
  <main>
    <div class="document-section">
      <div class="container">
        <div ref="cookieDeclarationRef" />
      </div>
    </div>
  </main>
</template>
